import request from '@/utils/request'
// 获取简历详情
export function JS_GetMyResume (JSId) {
  return request({
    url: 'system/jobseeker/' + JSId,
    method: 'get',
  })
}
// 获取简历详情
export function JS_GetMyResumeReId (ReId) {
  return request({
    url: 'system/resume/' + ReId,
    method: 'get',
  })
}
// 保存简历信息
export function JS_SaveResume (data) {
  return request({
    url: 'system/resume',
    method: 'post',
    data
  })
}
// 获取指定简历的求职意向列表
export function JS_GetReJobwantList (params) {
  return request({
    url: 'system/rejobwant/list',
    method: 'get',
    params
  })
}
// 获取求职意向详情
export function JS_GetReJobwant (ReJWId) {
  return request({
    url: 'system/rejobwant/' + ReJWId,
    method: 'get',
  })
}
// 保存求职意向信息
export function JS_SaveReJobwant (data) {
  return request({
    url: 'system/rejobwant',
    method: 'post',
    data
  })
}
// 删除求职意向信息
export function JS_DeleteReJobwant (ReJWId) {
  return request({
    url: 'system/rejobwant/' + ReJWId,
    method: 'delete',
  })
}
// 获取指定简历的工作经历列表
export function JS_GetReWorkList (params) {
  return request({
    url: 'system/rework/list',
    method: 'get',
    params
  })
}
// 获取工作经历信息
export function JS_GetReWork (RWId) {
  return request({
    url: 'system/rework/' + RWId,
    method: 'get',
  })
}
// 保存工作经历
export function JS_SaveReWork (data) {
  return request({
    url: 'system/rework',
    method: 'post',
    data
  })
}
// 删除工作经历
export function JS_DeleteReWork (RWId) {
  return request({
    url: 'system/rework/' + RWId,
    method: 'delete',
  })
}
// 获取指定简历的教育经历列表
export function JS_GetReEducationList (params) {
  return request({
    url: 'system/reedu/list',
    method: 'get',
    params
  })
}
// 获取教育经历信息
export function JS_GetReEducation (ReEId) {
  return request({
    url: 'system/reedu/' + ReEId,
    method: 'get',
  })
}
// 保存教育经历信息
export function JS_SaveReEducation (data) {
  return request({
    url: 'system/reedu',
    method: 'post',
    data
  })
}
// 删除教育经历
export function JS_DeleteReEducation (ReEId) {
  return request({
    url: 'system/reedu/' + ReEId,
    method: 'delete',
  })
}
// 获取指定简历的项目经历列表
export function JS_GetReProjectList (params) {
  return request({
    url: 'system/reproject/list',
    method: 'get',
    params
  })
}
// 获取项目经历信息
export function JS_GetReProject (RePId) {
  return request({
    url: 'system/reproject/' + RePId,
    method: 'get',
    params
  })
}
// 保存项目经验信息
export function JS_SaveReProject (data) {
  return request({
    url: 'system/reproject',
    method: 'post',
    data
  })
}
// 删除项目经历
export function JS_DeleteReProject (RePId) {
  return request({
    url: 'system/reproject/' + RePId,
    method: 'delete',
  })
}
// 获取指定简历的语言能力列表
export function JS_GetReLanguageList (params) {
  return request({
    url: 'system/corelanguage/list',
    method: 'get',
    params
  })
}
// 获取语言能力信息
export function JS_GetReLanguage (ReLId) {
  return request({
    url: 'system/corelanguage/' + ReLId,
    method: 'get',
  })
}
// 保存语言能力信息
export function JS_SaveReLanguage (data) {
  return request({
    url: 'system/corelanguage',
    method: 'post',
    data
  })
}
// 删除语言能力
export function JS_DeleteReLanguage (ReLId) {
  return request({
    url: 'system/corelanguage/' + ReLId,
    method: 'delete',
  })
}
// 获取指定简历的专业技能列表
export function JS_GetReSkillList (params) {
  return request({
    url: 'system/reskill/list',
    method: 'get',
    params
  })
}
// 获取专业技能详情
export function JS_GetReSkill (ReSId) {
  return request({
    url: 'system/reskill/' + ReSId,
    method: 'get',
  })
}
// 保存专业技能
export function JS_SaveReSkill (data) {
  return request({
    url: 'system/reskill',
    method: 'post',
    data
  })
}
// 删除专业技能
export function JS_DeleteReSkill (ReSId) {
  return request({
    url: 'system/reskill/' + ReSId,
    method: 'delete',
  })
}
// 获取指定简历的证书列表
export function JS_GetReCertificateList (params) {
  return request({
    url: 'system/recert/list',
    method: 'get',
    params
  })
}
// 获取证书信息
export function JS_GetReCertificate (ReCId) {
  return request({
    url: 'system/recert/' + ReCId,
    method: 'get',
  })
}
// 保存证书信息
export function JS_SaveReCertificate (data) {
  return request({
    url: 'system/recert',
    method: 'post',
    data
  })
}
// 删除证书
export function JS_DeleteReCertificate (ReCId) {
  return request({
    url: 'system/recert/' + ReCId,
    method: 'delete',
  })
}

// 获取指定简历的培训经历列表
export function JS_GetReTrainList (params) {
  return request({
    url: 'system/retrain/list',
    method: 'get',
    params
  })
}
// 保存培训经历信息
export function JS_SaveReTrain (data) {
  return request({
    url: 'system/retrain',
    method: 'post',
    data
  })
}
// 获取职位信息列表
export function JS_GetJobPage (params) {
  return request({
    url: 'Job/JS_GetJobPage',
    method: 'get',
    params
  })
}
// 获取职位信息列表
export function WeGetJobPage (params) {
  return request({
    url: 'system/job/list',
    method: 'get',
    params
  })
}
// 投递简历
export function JS_ReDeliver (params) {
  return request({
    url: 'system/jobseeker/applyJob',
    method: 'get',
    params
  })
}
// 获取职业类型信息列表
export function GetAbilityList (params) {
  return request({
    url: 'Ability/GetAbilityList',
    method: 'get',
    params
  })
}
// 获取个人信息
export function GetLoginSeeker (data) {
  return request({
    url: 'JSPlat/GetLoginSeeker',
    method: 'post',
    data
  })
}
// 获取我投递的简历
export function JS_GetMyReDeliverList (params) {
  return request({
    url: 'system/redeliver/list',
    method: 'get',
    params
  })
}
// 修改密码
export function paasswords (params) {
  return request({
    url: 'system/jobseeker/updatePwd',
    method: 'get',
    params
  })
}
// 验证者用户
export function CheckSeeker (params) {
  return request({
    url: 'system/jobseeker/loginIn',
    method: 'get',
    params
  })
}
//注册用户，第一步，基本信息注册及验证
export function RegisterOne (params) {
  return request({
    url: 'system/tverifyinfo/checkcode',
    method: 'get',
    params
  })
}
//注册完成
export function RegisterOver (data) {
  return request({
    url: 'system/jobseeker/register',
    method: 'post',
    data
  })
}
// 获取短信验证码
export function SendValidedMsg (params) {
  return request({
    url: 'system/tverifyinfo/getcode',
    method: 'get',
    params
  })
}
// 生成图片验证码
export function GenerateImgValidCode (params) {
  return request({
    url: 'Plat/GenerateImgValidCode',
    method: 'get',
    params
  })
}
// 删除培训经历
export function JS_DeleteReTrain (ReTId) {
  return request({
    url: 'system/retrain/' + ReTId,
    method: 'delete',
  })
}
// 获取企业详情
export function WxGetEnterprise (params) {
  return request({
    url: 'Enterprise/WxGetEnterprise',
    method: 'get',
    params
  })
}
// 获取职位详情
export function WeGetJobDetail (JId) {
  return request({
    url: 'system/job/' + JId,
    method: 'get',
  })
}

// 获取字典别表
export function GetCodeEntrysList (params) {
  return request({
    url: 'system/dict/data/type/' + params,
    method: 'get',
  })
}
// 获取字典别表 树形
export function GetCodeEntrysTree (params) {
  return request({
    url: 'system/dict/data/typeTree/' + params,
    method: 'get',
  })
}